import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'

const PreviewModal = ({ open, onClose, data = {} }: {open: boolean, onClose: () => void, data: any}) => {

  return (
    <Transition.Root show={open} as={Fragment}>
      <div>
        <Dialog 
            as="div" 
            className="relative z-[60]"
            onClose={onClose}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-[60] w-screen overflow-y-auto" onClick={onClose}>
              <div className="flex min-h-full justify-center items-center text-center">
                {/* <span 
                  className="
                    absolute
                    top-6
                    right-6
                    bg-gray-200 
                    text-gray-900 
                    rounded-lg 
                    text-sm 
                    w-8 
                    h-8 
                    border-0 
                    ms-auto 
                    inline-flex 
                    justify-center 
                    items-center 
                    ring-transparent 
                    cursor-pointer
                  " 
                  data-modal-hide="static-modal"
                  onClick={onClose}
                >
                  <XMarkIcon width={20} height={20} />
                </span> */}

                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <div className="w-[375px] h-[375px] bg-white max-w-full m-3 box-border">
                    <img src={data ?? ""} alt='Preview' />
                  </div>
                </Transition.Child>
              </div>
            </div>
          </Dialog>

      </div>
    </Transition.Root>
  )
}

export default PreviewModal;